import React, { useEffect } from "react";
import "../common.css";
import { Box, Drawer, Typography, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import VideoLibraryOutlinedIcon from "@mui/icons-material/VideoLibraryOutlined";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { updateLoading, updateQuery, resetQuery } from "../redux/querySlice";
import ResultsNew from "./ResultsNew";
import { useTheme } from "@mui/material";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  // padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const StoryPage = (props) => {
  const queryTextRedux = useSelector((state) => state.queryText.value);
  const resetQueryRedux = useSelector((state) => state.queryText.resetQuery);
  const activityRedux = useSelector((state) => state.activity.activity);
  const loadingHistoryRedux = useSelector(
    (state) => state.activity.loadingHistory
  );
  const historyID = useSelector((state) => state.historicalChatID.value);
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const thisPath = window.location.pathname;
  const thisPathSegments = thisPath.split("/").filter((segment) => segment);

  const sessionMode = sessionStorage.getItem("mode");

  const [mode, setMode] = React.useState(sessionMode || "light");
  const [zeroState, setZeroState] = React.useState(true);
  const [queryText, setQueryText] = React.useState("");
  const [firstQuery, setFirstQuery] = React.useState(false);
  const [resultsList, setResultsList] = React.useState([]);

  const [openAltClipsPanel, setOpenAltClipsPanel] = React.useState(false);
  const [altClipsDrawerContent, setAltClipsDrawerContent] = React.useState([]);
  const [openDebugPanel, setOpenDebugPanel] = React.useState(false);
  const [debugDrawerContent, setDebugDrawerContent] = React.useState([]);
  const [validError, setValidError] = React.useState(false);

  const handleAltCLipsPanelClose = () => {
    setOpenAltClipsPanel(false);
  };

  const scrollToBottom = () => {
    let chatBottom = document.getElementById("chatboxBottom");
    if (chatBottom) {
      window.setTimeout(() => {
        chatBottom.scrollIntoView({ behavior: "smooth", block: "start" });
        const offset = window.innerHeight * 0.25 || 150;
        window.scrollBy({ top: -offset, behavior: "smooth" });
      }, 0);
    }
  };

  const scrollToTop = () => {
    var evt = document.createEvent("MouseEvents");
    evt.initEvent("wheel", true, true);
    evt.deltaY = +120;
    evt.deltaY = -120;
    document.getElementById("main-container").dispatchEvent(evt);
  };

  const handleChatReset = () => {
    // setResultsList([]);
    navigate("/");
    // dispatch(updateQuery(""));
    window.location.reload();
  };

  const handleQuery = () => {
    if (
      queryTextRedux.length > 0 &&
      thisPathSegments[thisPathSegments.length - 1] === "story"
    ) {
      setFirstQuery(false);
      dispatch(updateLoading(true));
      dispatch(updateQuery(queryText));
      // sendToResults();
      setQueryText("");
    } else {
      setFirstQuery(true);
      dispatch(updateLoading(true));
      dispatch(updateQuery(queryText));
      setQueryText("");
    }
  };

  const sendToResults = () => {
    // if (thisPathSegments[thisPathSegments.length - 1] !== "story") {
    //   navigate("/q/" + encodeURIComponent(queryTextRedux) + "/story");
    // }

    if (queryTextRedux.length !== "" && activityRedux.length === 0) {
      setZeroState(false);
      if (resultsList.length > 0 && resultsList[0].props.queryText == "") {
        setResultsList([
          <ResultsNew
            queryText={queryTextRedux}
            isHistory={activityRedux.length > 0}
            theme={mode}
            open_alt_clips_panel={setOpenAltClipsPanel}
            alt_clips_drawer={setAltClipsDrawerContent}
            open_debug_panel={setOpenDebugPanel}
            debug_drawer={setDebugDrawerContent}
          />,
        ]);
      } else {
        setResultsList(
          // resultsList.concat(
          <ResultsNew
            queryText={queryTextRedux}
            isHistory={activityRedux.length > 0}
            theme={mode}
            open_alt_clips_panel={setOpenAltClipsPanel}
            alt_clips_drawer={setAltClipsDrawerContent}
            open_debug_panel={setOpenDebugPanel}
            debug_drawer={setDebugDrawerContent}
          />
        );
        // );
      }
    } else if (activityRedux.length > 0) {
      console.log("activityredux.length > 0");
      setZeroState(false);
      setResultsList([
        <ResultsNew
          queryText={queryTextRedux}
          isHistory={true}
          chatID={historyID}
          addToHistory={true}
          activityLog={activityRedux}
          theme={mode}
          open_alt_clips_panel={setOpenAltClipsPanel}
          alt_clips_drawer={setAltClipsDrawerContent}
          open_debug_panel={setOpenDebugPanel}
          debug_drawer={setDebugDrawerContent}
        />,
      ]);
    } else {
      setZeroState(false);
      console.log("oi oi, we are adding to history");
      if (resultsList.length > 0) {
        setResultsList([
          <ResultsNew
            queryText={queryTextRedux}
            isHistory={false}
            theme={mode}
            open_alt_clips_panel={setOpenAltClipsPanel}
            alt_clips_drawer={setAltClipsDrawerContent}
            open_debug_panel={setOpenDebugPanel}
            debug_drawer={setDebugDrawerContent}
          />,
        ]);
      } else {
        setResultsList(
          resultsList.concat(
            <ResultsNew
              queryText={queryTextRedux}
              isHistory={false}
              theme={mode}
            />
          )
        );
      }
    }
  };

  useEffect(() => {
    const smith = document.getElementById("ask-smith");
    if (smith) {
      smith.value = "";
      // scrollToBottom();
    }

    if (queryText.length > 0 || queryTextRedux.length > 0) {
      setZeroState(false);
      // scrollToBottom();
      sendToResults();
      // if (LLMPrompt !== DefaultLLMPrompt) {
      //   setResultsList(resultsList.concat(<ResultsNew queryText={queryTextRedux} isHistory={false} theme={mode} instruction_prompt={LLMPrompt} />));
      // } else {
      //   setResultsList(resultsList.concat(<ResultsNew queryText={queryTextRedux} isHistory={false} theme={mode} />));
      // }
    }

    // if (activityRedux.length > 0) {
    //   console.log("adding to activity with chatID: ", historyID)
    //   setResultsList(<ResultsNew queryText={queryTextRedux} isHistory={activityRedux.length > 0} addToHistory={true} chatID={historyID} activityLog={activityRedux} theme={mode}/>)
    // }

    if (
      queryTextRedux.length > 1 &&
      activityRedux.length > 1 &&
      historyID.length > 1
    ) {
      setResultsList([
        <ResultsNew
          queryText={queryTextRedux}
          isHistory={activityRedux.length > 0}
          chatID={historyID}
          addToHistory={true}
          activityLog={activityRedux}
          theme={mode}
          open_alt_clips_panel={setOpenAltClipsPanel}
          alt_clips_drawer={setAltClipsDrawerContent}
          open_debug_panel={setOpenDebugPanel}
          debug_drawer={setDebugDrawerContent}
        />,
      ]);
    }
    if (firstQuery) {
      scrollToTop();
    } else {
      scrollToBottom();
    }
  }, [queryTextRedux]);

  return (
    <Box flex={3}>
      {resultsList}
      <Drawer
        open={openAltClipsPanel}
        anchor="right"
        PaperProps={{
          sx: {
            backgroundColor:
              sessionStorage.getItem("mode") === "light"
                ? "#FFFFFF"
                : "#000000",
            border: 0,
            margin: "60px 12px 12px",
            borderRadius: "12px",
            height: "calc(100% - 84px)",
            boxShadow: "0 0 15px rgba(0, 0, 0, 0.1)",
            // width: mini ? '64px' : drawerWidth,
          },
        }}
        sx={{
          width: window.innerWidth * 0.33,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width:
              window.innerWidth < 600
                ? "calc(100% - 24px)"
                : window.innerWidth * 0.33,
            boxSizing: "border-box",
          },
        }}
      >
        <DrawerHeader
          sx={{
            // position: "fixed",
            background: theme.palette.background.dark,
            borderRadius: "24px 24px 0 0",
            width: "inherit",
            margin: 0,
            borderBottom: "1px solid #ccc",
            zIndex: 999,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              margin: 2,
              fontFamily: "Roboto Condensed",
              fontWeight: 600,
              width: "100%",
            }}
          >
            <VideoLibraryOutlinedIcon
              sx={{ mr: 2, fontSize: 24, verticalAlign: "middle" }}
            />
            Alternate Clips
          </Typography>
          <IconButton onClick={handleAltCLipsPanelClose}>
            {<CloseIcon />}
          </IconButton>
        </DrawerHeader>
        <div>{altClipsDrawerContent}</div>
      </Drawer>
    </Box>
  );
};

export default StoryPage;
